<div class="position-relative">


    <!-- <ul class="nav">
    <li class="nav-items"><a class="nav-link"><i class="fi fi-br-order-history"></i> მიმდინარე შეკვეთები</a></li>
    <li class="nav-items"><a class="nav-link"><i class="fi fi-br-shopping-cart-check"></i> გასული შეკვეთები</a></li>
    <li class="nav-items"><a class="nav-link" (click)="isTable = !isTable"><i class="fi fi-br-lamp"></i> მაგიდები</a></li>
  </ul> -->

<app-spinner *ngIf="loadCheck"></app-spinner>
<app-pack-minimal *ngIf="isMinimal"></app-pack-minimal>

<div #collapse="ngbCollapse" [(ngbCollapse)]="isTable">
  <app-app-tables *ngIf="!loadCheck"></app-app-tables>
</div>

<!-- <button (click)="enableSound()">ჩართე ხმა</button> -->

<div class="container order-container mt-3"  *ngIf="!loadCheck">



  <div class="row m-auto">
    <div *ngFor="let order of orders; let i = index" class="order-card">
      <div class="order-header">
        <h6 class="d-flex">
          <span *ngIf="order.type == 'DINE IN'"> <i class="fi fi-br-lamp"></i> {{ 'ORDER.ORDER_TYPE.DINE_IN' | translate }},</span>
          <span *ngIf="order.type == 'TAKEAWAY'"><i class="fi fi-br-box-open"></i> {{ 'ORDER.ORDER_TYPE.TAKEAWAY' | translate }}</span>
          <span *ngIf="order.type == 'DELIVERY'"><i class="fi fi-br-shipping-fast"></i> {{ 'ORDER.ORDER_TYPE.DELIVERY' | translate }}</span>
           <span *ngIf="order.table_number"> მაგიდა: {{ order.table_number }}</span>
        </h6>
        <p class="order-time d-flex">
          <i class="fi fi-rr-calendar mx-1"></i> 
          {{ order.timestamp | date:'d.M.Y' }} 
          <i class="fi fi-rr-clock-three mx-1"></i> 
          {{ order.timestamp | date:'HH:mm' }}
        </p>
      </div>
      
      <div class="order-body">
        <ul class="order-items">
          <li *ngFor="let product of order.products">
            <div>
              <span class="fw-bold">{{ product.quantity }} x {{ product.name }}</span>
              <span>{{ product.price }} ₾</span>
            </div>
            
            <!-- ინგრედიენტების ჩვენება -->
            <ul *ngIf="product.ingredients?.length > 0" class="ingredients-list">
              <li *ngFor="let ingredient of product.ingredients" 
                      [ngClass]="{'text-danger': !ingredient.check, 'selected-ingredient': ingredient.check}">
                    {{ ingredient.name }} 
                    <!-- თუ ინგრედიენტი ამოღებულია -->
                    <span *ngIf="!ingredient.check">({{ 'ORDER.WITHOUT' | translate }})</span>
                    <!-- პირობითი გამოთქმა რაოდენობისთვის -->
                    <span *ngIf="ingredient.check && ingredient.type">
                      ( 
                      <span *ngIf="ingredient.quantity == 0">{{ 'ORDER.QUANTITY.LESS' | translate }}</span>
                      <span *ngIf="ingredient.quantity == 1">{{ 'ORDER.QUANTITY.MEDIUM' | translate }}</span>
                      <span *ngIf="ingredient.quantity == 2">{{ 'ORDER.QUANTITY.MORE' | translate }}</span>
                      )
                    </span>
                    <!-- <span *ngIf="ingredient.ig_price"> 
                      {{ingredient.ig_price}}<span [innerHTML]="currency?.logo"></span>
                    </span> -->
                </li>
            </ul>
          </li>
        </ul>
        <h5 class="order-total">{{ order.total_price }} ლ</h5>
      </div>

      <div class="card mt-3 p-3" *ngIf="order.comment">
        <b>კომენტარი: </b>
        <p>{{ order.comment }}</p>
      </div>
      
      <div class="order-footer d-flex justify-content-center">

         <!-- მომხმარებლის ინფორმაციის ჩვენების ღილაკი, თუ შეკვეთა არ არის DINE IN -->
        <button *ngIf="order.type !== 'DINE IN'" class="btn btn-primary btn-sm me-2" (click)="toggleCustomerInfo(i)">
          {{ customerInfoVisible[i] ? 'Hide' : 'Show' }} Customer Info
        </button>

        <!-- დასაწყისი ღილაკები: დაწყება და უარყოფა -->
        <button 
          *ngIf="order.status === 'Pending'" 
          class="btn btn-success btn-sm me-2" 
          (click)="updateStatus(order.id, 'In Preparation')" 
          [disabled]="loadingMap[order.id + '_In Preparation']">
          
          <span *ngIf="!loadingMap[order.id + '_In Preparation']">დაწყება</span>
          <span *ngIf="loadingMap[order.id + '_In Preparation']" class="d-flex">
            <app-spinner [loading]="true" class="mx-2" [sm]="true"></app-spinner>
            <span class="ms-1">იტვირთება...</span>
          </span>
        </button>

        <button 
          *ngIf="order.status === 'Pending'" 
          class="btn btn-danger btn-sm me-2" 
          (click)="updateStatus(order.id, 'Rejected')" 
          [disabled]="loadingMap[order.id + '_Rejected']">
          
          <span *ngIf="!loadingMap[order.id + '_Rejected']">უარყოფა</span>
          <span *ngIf="loadingMap[order.id + '_Rejected']" class="d-flex">
            <app-spinner [loading]="true" class="mx-2" [sm]="true"></app-spinner>
            <span class="ms-1">იტვირთება...</span>
          </span>
        </button>

        <!-- უარყოფილი შეკვეთისთვის ღილაკი -->
        <button *ngIf="order.status === 'Rejected'" class="btn btn-danger btn-sm me-2" disabled>
          უარყოფილი
        </button>

         <!-- უარყოფილი შეკვეთისთვის ღილაკი -->
        <button *ngIf="order.status === 'Completed'" class="btn btn-info btn-sm me-2" disabled>
          დასრულებული
        </button>
      
        <button 
          *ngIf="order.status === 'In Preparation'" 
          class="btn btn-info btn-sm me-2" 
          (click)="nextStep(order)"
          [disabled]="loadingMap[order.id + '_NextStep']">

          <span *ngIf="!loadingMap[order.id + '_NextStep']">
            {{ order.type === 'DINE IN' ? 'კერძის დასრულება' : (order.type === 'DELIVERY' ? 'ტრანსპორტირების მზადება' : 'წასაღებად მზადაა') }}
          </span>

          <span *ngIf="loadingMap[order.id + '_NextStep']" class="d-flex">
            <app-spinner [loading]="true" class="mx-2" [sm]="true"></app-spinner>
            <span class="ms-1">იტვირთება...</span>
          </span>
        </button>

        <!-- კურიერის მოქმედებები -->
        <button *ngIf="order.status === 'Ready for Transport'" class="btn btn-warning btn-sm me-2" (click)="updateStatus(order.id, 'In Transit')" [disabled]="loadingMap[order.id + '_In Transit']">
          <span *ngIf="!loadingMap[order.id + '_In Transit']">გზაში</span>
          <span *ngIf="loadingMap[order.id + '_In Transit']" class="d-flex">
            <app-spinner [loading]="true" class="mx-2" [sm]="true"></app-spinner>
            <span class="ms-1">იტვირთება...</span>
          </span>
        </button>
  
      
        <!-- შეკვეთის დასრულება -->
        <button *ngIf="order.status === 'In Transit' || order.status === 'Ready for Pickup'" class="btn btn-success btn-sm me-2" (click)="updateStatus(order.id, 'Completed')" [disabled]="loadingMap[order.id + '_Completed']">
          <span *ngIf="!loadingMap[order.id + '_Completed']">დასრულება</span>
          <span *ngIf="loadingMap[order.id + '_Completed']" class="d-flex">
            <app-spinner [loading]="true" class="mx-2" [sm]="true"></app-spinner>
            <span class="ms-1">იტვირთება...</span>
          </span>
        </button>

        
        
      </div>
      
      <!-- მომხმარებლის ინფორმაციის ჩვენება, თუ შეკვეთა არ არის DINE IN -->
      <div *ngIf="customerInfoVisible[i] && order.type !== 'DINE IN'" class="customer-info mt-3">
        <p><strong>{{"NAME" | translate}}:</strong> {{ order.customer_name || 'N/A' }}</p>
        <p><strong>{{"PHONE" | translate}}:</strong> {{ order.customer_phone || 'N/A' }}</p>
        <p *ngIf="order.type === 'DELIVERY'"><strong>{{"ADDRESS" | translate}}:</strong> {{ order.delivery_address || 'N/A' }}</p>
      </div>
    </div>
  </div>

</div>
</div>